// @ts-nocheck
import {
    addressDrawerSelectCustomerContainerStyles,
    AddressDrawerSelectCustomerContainerStyles,
} from "@insite/content-library/Widgets/Header/AddressDrawerSelectCustomerContainer";
import { formGridProps } from "@store/Themes/common/props/form";

Object.assign<AddressDrawerSelectCustomerContainerStyles>(addressDrawerSelectCustomerContainerStyles, {
    container: formGridProps.gridContainer,
    billToGridItem: { width: 12 },
    billToSelector: {
        billToSelectorDynamicDropdown: {
            sizeVariant: "small",
        },
    },
    shipToSelector: {
        shipToSelectorDynamicDropdown: {
            sizeVariant: "small",
        },
    },
    shipToGridItem: { width: 12 },
    isDefaultGridItem: { width: 12 },
});
